import {
  MODAL_CONFIRMATION_OPEN,
  MODAL_CONFIRMATION_CLOSE,
  MODAL_CONFIRMATION_SAVE_CHANGES,
  MODAL_CONFIRMATION_VALIDATE,
  MODAL_CONFIRMATION_CANCEL,
  MODAL_CONFIRMATION_RESET,
} from '../actions/modal_confirmation'

export function modalConfirmation(
  state = {
    isModalConfirmationOpen: false,
    newState: null,
    isTxChangesSaved: false,
    isValidated: true,
  },
  action
) {
  switch (action.type) {
    case MODAL_CONFIRMATION_OPEN:
      return {
        ...state,
        isModalConfirmationOpen: true,
        newState: action.newState,
      }
    case MODAL_CONFIRMATION_CLOSE:
      return {
        ...state,
        isModalConfirmationOpen: false,
        isTxChangesSaved: false,
        isValidated: true,
      }
    case MODAL_CONFIRMATION_CANCEL:
      return {
        ...state,
        isModalConfirmationOpen: false,
        isTxChangesSaved: false,
        isValidated: true,
        newState: null, // action.newState
      }
    case MODAL_CONFIRMATION_SAVE_CHANGES:
      return {
        ...state,
        isTxChangesSaved: true,
      }
    case MODAL_CONFIRMATION_VALIDATE:
      return {
        ...state,
        isValidated: action.isValidated,
      }
    case MODAL_CONFIRMATION_RESET:
      return {
        ...state,
        newState: null,
        isTxChangesSaved: false,
      }
    default:
      return state
  }
}
